import React, { useEffect, useState } from "react";
import request from "../../../Helpers/API";
import Swal from "sweetalert2";
import { ValFormReg } from "../../../Validators/ValForms";
import { RegularExpressions } from "../../../Helpers/RegularExpression";
import { TextField } from "@mui/material";
import { ValSpecialCharacters } from "../../../Validators/ValSpecialCharacters";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import WarningIcon from "@mui/icons-material/Warning";
import PendingIcon from "@mui/icons-material/Pending";
import ErrorIcon from "@mui/icons-material/Error";
import { ResumenComparativoHDEquip } from "../ResumenComparativoHDEquip";
import {
    construirResumenComparativo,
    obtenerInconsistencias,
} from "../../../Helpers/ResumenComparativoHelper";


export const PrestamoFinalizacion = ({
    folio,
    setLoader,
    loader,
    updateComentarios,
}) => {
    const [comentarios, setComentarios] = useState("");
    const [estatus, setEstatus] = useState({});
    const [resumenFacturacion, setResumenFacturacion] = useState([]);
    const [resumenTasas, setResumenTasas] = useState([]);
    const onChange = (prop, value, sbool, smensaje) => {
        setComentarios(value);
    };
    useEffect(() => {
        onCargarProceso()
    }, []);

    const onCargarProceso = () => {
        setLoader({ ...loader, mostrar: true });
        const post = {
            folio,
            idproceso: 38,
            responsable: "G",
        };
        request
            .post(`ACAnalisisDecicion/ObtenerResumen`, post)
            .then((result) => {
                console.log(result)
                setLoader({ ...loader, mostrar: false });
                setEstatus(result.estado);
                setResumenFacturacion(result.resumen_facturacion);
                setResumenTasas(result.resumen_tasas);
            })
            .catch((error) => {
                setLoader({ ...loader, mostrar: false });
                Swal.fire(
                    "ANALISIS DE SOLICITUD DE CREDITO",
                    JSON.stringify(error),
                    "error"
                );
            });
    }

    const onModificarCliente = (idcliente) => {
        setLoader({ ...loader, mostrar: true });

        request
            .get(`ACAnalisisDecicion/ModificarIDCliente?idcliente=${idcliente}&folio=${folio}`)
            .then((result) => {
                setLoader({ ...loader, mostrar: false });
                Swal.fire(
                    "MODIFICAR ID CLIENTE",
                    "Cliente Modificado",
                    "success"
                );
                onCargarProceso()
            })
            .catch((error) => {
                setLoader({ ...loader, mostrar: false });
                Swal.fire(
                    "ANALISIS DE SOLICITUD DE CREDITO",
                    JSON.stringify(error),
                    "error"
                );
            });
    }

    const onEnviarComentario = (accion) => {
        const rescomentarios = ValFormReg(
            "Comentarios",
            comentarios,
            RegularExpressions.TextSpecialCharacter,
            15,
            2000
        );
        if (rescomentarios.isValid === false) {
            Swal.fire(
                "ANALISIS DE SOLICITUD DE CREDITO",
                rescomentarios.mensaje,
                "error"
            );
            return;
        }
        setLoader({ ...loader, mostrar: true });
        const post = {
            folio,
            idproceso: 38,
            consecutivo: -1,
            comentarios,
            estatus: accion,
        };
        request
            .post("ACTimeLineComentarios", post)
            .then((result) => {
                setLoader({ ...loader, mostrar: false });
                setEstatus(result);
                setComentarios("");

                if (updateComentarios !== undefined && updateComentarios !== null)
                    updateComentarios();
            })
            .catch((error) => {
                setLoader({ ...loader, mostrar: false });
                Swal.fire(
                    "ANALISIS DE SOLICITUD DE CREDITO",
                    JSON.stringify(error),
                    "error"
                );
            });
    };
    // Detalle de qué no cuadra (para la advertencia de "no se puede finalizar").
    // idequip excluido: en este proceso no se valida el ID Cliente.
    const inconsistenciasFacturacion = obtenerInconsistencias(
        construirResumenComparativo(resumenFacturacion, "_facturacion", ["idequip"]),
        "EQUIP"
    );
    const inconsistenciasTasas = obtenerInconsistencias(
        construirResumenComparativo(resumenTasas, "_tasas", ["idequip"]),
        "TASAS"
    );
    const inconsistencias = [
        ...inconsistenciasFacturacion,
        ...inconsistenciasTasas,
    ];

    const OnGetIcon = ({ icon }) => {
        switch (icon) {
            case "wait":
                return <PendingIcon />;
            case "success":
                return <CheckCircleIcon />;
            case "warning":
                return <WarningIcon />;
            case "error":
                return <ErrorIcon />;
            default:
                <></>;
        }
    };
    return (
        <div className="analisis-credito-modal-mhusa">
            <div className="analisis-credito-modal-mhusa-content">
                <div className="analisis-credito-modal-mhusa-content-buttons">
                    {estatus.habilitar === undefined ||
                        estatus.habilitar === null ||
                        estatus.habilitar === false ? (
                        <div
                            className={`analisis-credito-modal-mhusa-content-comentarios analisis-credito-modal-mhusa-content-comentarios-${estatus.icono}`}
                        >
                            <div className="analisis-credito-modal-mhusa-content-comentarios-svg">
                                <OnGetIcon icon={estatus.icono} />
                            </div>
                            <div className="analisis-credito-modal-mhusa-content-comentarios-div">
                                {estatus.comentarios}
                            </div>
                        </div>
                    ) : (
                        <div className="analisis-credito-modal-mhusa-content-buttons-container">
                            <TextField
                                fullWidth
                                size="small"
                                label="Comentarios"
                                className="cel-1"
                                multiline
                                rows={4}
                                type="text"
                                // error={condiciones.bcondiciones}
                                onChange={({ target }) => {
                                    ValSpecialCharacters(
                                        "condiciones",
                                        target.value,
                                        onChange,
                                        true,
                                        500
                                    );
                                }}
                                value={comentarios}
                            />
                            <ResumenComparativoHDEquip
                                titulo="RESUMEN COMPARATIVO"
                                registros={resumenFacturacion}
                                onModificarIdCliente={onModificarCliente}
                                conceptosExcluidos={["idequip"]}
                            />

                            {estatus.diferencias_documentos_tasas > 0 || estatus.diferencias_documentos_facturacion > 0 ? (
                                <></>
                            ) : (
                                <div className="analisis-credito-modal-mhusa-content-buttons-container-buttons">
                                    <div
                                        className="analisis-credito-modal-mhusa-content-acept-button"
                                        onClick={() => {
                                            onEnviarComentario("A");
                                        }}
                                    >
                                        <CheckCircleIcon />
                                        <div>Finalizar Crédito</div>
                                    </div>

                                </div>
                            )}

                        </div>
                    )}
                </div>

            </div>
        </div>
    );
};
